<script setup lang="ts">
import { Analytics } from '@/components';
</script>

<template>
  <div class="analytics-container">
    <Analytics />
  </div>
</template>

<style scoped lang="scss">
.analytics-container {
  height: 100%;
  overflow-y: scroll;
}
</style>
